import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import AboutLeftTab from "../About/AboutLeftTab";

function EventDetails() {

  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEvent();
  }, [id]);

  const fetchEvent = async () => {
    try {

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/Home/GetEventsDetailsApi/${id}`
      );

      if (res.data.status === "Success") {

        const item = res.data.data;

        setEvent({
          id: item.Id,
          title: item.Title,
          subtitle: item.Sub_Title,
          description: item.Description,
          banner: item.Banner_Img,
          images: item.Images ? item.Images.split(",") : [],
          department: item.Department,
          status: item.Status,
          createdDate: item.Created_Date,
          eventDate: item.EventDate
        });
      }
    } catch (err) {
      console.error("Event fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div>
        <Navbar />
        <div className="text-center my-5">
          <div className="spinner-border text-danger"></div>
        </div>
        <Footer />
      </div>
    );
  }

  if (!event) {
    return (
      <div>
        <Navbar />
        <div className="text-center my-5">
          <h4>Event not found</h4>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Navbar />

      <div className="graduate-admission pt-lg-5 pt-4 pb-70">
        <div className="container">
          <div className="row">

            <AboutLeftTab />

            <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">

              <div className="how-to-apply">

                <h2>{event.title}</h2>

                {event.subtitle && <h5 className="text-muted">{event.subtitle}</h5>}

                {/* {event.banner && (
  <img
    className="img-fluid my-3"
    src={`${process.env.REACT_APP_API_URL}${event.banner}`}
    alt={event.title}
  />
)} */}


                {/* Description */}
                <p style={{ whiteSpace: "pre-line" }}>
                  {event.description}
                </p>

                {/* Gallery */}
                {event.images.length > 0 && (
                  <div className="row mt-4">

                    {event.images.map((img, index) => (
                      <div key={index} className="col-md-4 mb-3">

                        <img
                          src={`${process.env.REACT_APP_API_URL}${img}`}
                          alt={event.title}
                          className="img-fluid sixteen-nine rounded"
                          loading="lazy"
                        />

                      </div>
                    ))}

                  </div>
                )}

              </div>

            </div>

          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default EventDetails;